
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { GroupComponent } from './group.component';

import { FormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";

@NgModule({
    declarations: [
        GroupComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
    ],
    providers: [],
    bootstrap: [GroupComponent]
})
export class GroupModule { }
